import dynamic from 'next/dynamic';
import { PreferredPaymentConfirmationProps } from './PreferredPaymentConfirmation.types';

export const PreferredPaymentConfirmation = dynamic<{ model: PreferredPaymentConfirmationProps }>(() =>
  import('./PreferredPaymentConfirmation').then(mod => mod.PreferredPaymentConfirmation)
);
